import { Space } from 'antd'
import { EmailTemplateButton } from './EmailTemplateButton'

const PreeventHandson = function () {
  return <Space size='small' orientation='vertical'>
    <p>Hands-on pre-event email templates</p>
    <EmailTemplateButton type='Pre-event - Hands-on' title='Registration confirmation' settingKey='pre-session.hands-on.registration' />
    <EmailTemplateButton type='Pre-event - Hands-on' title='Registration cancellation' settingKey='pre-session.hands-on.registration-cancellation' />
    <EmailTemplateButton type='Pre-event - Hands-on' title='Techcheck survey' settingKey='pre-session.hands-on.techcheck-survey' showSendButton />
    <EmailTemplateButton type='Pre-event - Hands-on' title='Login details' settingKey='pre-session.hands-on.login-details' showSendButton />
  </Space>
}

export default PreeventHandson
